var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69328",
    "data-name": "Group 69328",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.94,
    height: 143.954,
    viewBox: "0 0 150.94 143.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141839",
    "data-name": "Rectangle 141839",
    width: 150.94,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86052",
    "data-name": "Path 86052",
    d: "M65.138,58.036c-1.392,1.035-41.585,1.832-44.993,11.817s28.217,34.577,28.763,36.675-9.54,40.538-1.991,45.719c4.192,2.879,16.434-2.224,26.856-7.328,8.338-4.083,15.511-8.167,16.461-8.161,2.139.012,37.187,20.567,43.319,15.489s-2.027-44.568-1.289-46.423,31.275-28.43,28.059-35.971-42.689-10.821-44.288-11.817-15.33-39.106-25.8-39.106S66.53,57,65.138,58.036",
    transform: "translate(-19.888 -18.93)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 0.849,
    x2: 0.127,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#ffeb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ffd54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141837",
    "data-name": "Rectangle 141837",
    width: 80.006,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141835",
    "data-name": "Rectangle 141835",
    width: 18.12,
    height: 16.728,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69327",
    "data-name": "Group 69327",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69313",
    "data-name": "Group 69313"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69312",
    "data-name": "Group 69312",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86051",
    "data-name": "Path 86051",
    d: "M75.484,0C86.717,0,102.2,39.376,103.92,40.445s43.31,6.1,46.76,14.19-28.555,37.357-29.348,39.348,7.2,43.6.626,49.052-44.181-15.851-46.474-15.864-38.376,21.423-46.474,15.864,1.209-46.8.625-49.052S-3.37,65.346.288,54.634s45.264-13.08,46.758-14.19S64.25,0,75.484,0",
    transform: "translate(0 -0.001)",
    fill: "#ffbd39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69315",
    "data-name": "Group 69315",
    transform: "translate(5.137 4.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69314",
    "data-name": "Group 69314",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141834",
    "data-name": "Rectangle 141834",
    width: 201.368,
    height: 200.286,
    transform: "matrix(0.769, -0.64, 0.64, 0.769, -71.202, 56.65)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69326",
    "data-name": "Group 69326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69325",
    "data-name": "Group 69325",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86053",
    "data-name": "Path 86053",
    d: "M56.319,201.537c-.729-7.1,22.564-11.279,23.591-2.971s-22.6,12.645-23.591,2.971",
    transform: "translate(-41.761 -143.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86054",
    "data-name": "Path 86054",
    d: "M170.8,192.122c-.176-4.567,6.788-4.845,7.15-1.1.405,4.195-6.988,5.37-7.15,1.1",
    transform: "translate(-126.683 -139.768)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69324",
    "data-name": "Group 69324",
    transform: "translate(35.466 81.235)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69323",
    "data-name": "Group 69323"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69322",
    "data-name": "Group 69322",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69318",
    "data-name": "Group 69318",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69317",
    "data-name": "Group 69317"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69316",
    "data-name": "Group 69316",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86055",
    "data-name": "Path 86055",
    d: "M155.443,322.9c0,4.619-4.057,8.365-9.06,8.365s-9.06-3.746-9.06-8.365,4.057-8.363,9.06-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-137.323 -314.536)",
    fill: "#ff5f82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69321",
    "data-name": "Group 69321",
    transform: "translate(61.886)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69320",
    "data-name": "Group 69320"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69319",
    "data-name": "Group 69319",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86056",
    "data-name": "Path 86056",
    d: "M395.061,322.9c0,4.619-4.057,8.365-9.06,8.365s-9.06-3.746-9.06-8.365,4.058-8.363,9.06-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-376.941 -314.536)",
    fill: "#ff5f82"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86057",
    "data-name": "Path 86057",
    d: "M197.675,195.323c-11.609,1.089-8.463,25.064.868,24.609s10.742-25.7-.868-24.609",
    transform: "translate(-141.066 -144.852)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86058",
    "data-name": "Path 86058",
    d: "M228.377,237.205c-2.469-.319-3.253,5.57-.456,6.2s3.964-5.75.456-6.2",
    transform: "translate(-167.74 -175.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86059",
    "data-name": "Path 86059",
    d: "M335.067,195.323c11.611,1.089,8.461,25.064-.867,24.609s-10.742-25.7.867-24.609",
    transform: "translate(-242.383 -144.852)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86060",
    "data-name": "Path 86060",
    d: "M337.023,237.205c2.469-.319,3.255,5.57.456,6.2s-3.964-5.75-.456-6.2",
    transform: "translate(-248.368 -175.933)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86061",
    "data-name": "Path 86061",
    d: "M189.261,328.386c1.2-.9,50.687-.955,51.967,0,2.493,1.861,1.046,23.058-25.444,23.058s-28.984-21.2-26.523-23.058",
    transform: "translate(-139.834 -243.057)",
    fill: "#872a2a"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating4);
export default __webpack_public_path__ + "static/media/rating-4.1c0c2ebb34cd7090b23cc6075ad6f8df.svg";
export { ForwardRef as ReactComponent };